import { Component, OnInit, Input,Output,EventEmitter } from '@angular/core';
import { MyCourse } from 'src/app/models/my-course.model';

@Component({
  selector: 'app-my-course-item',
  templateUrl: './my-course-item.component.html',
  styleUrls: ['./my-course-item.component.css']
})
export class MyCourseItemComponent implements OnInit {

  @Input() hidePrice:boolean = false;
  @Input() course:MyCourse;
  @Output() routeToCourseDetail:EventEmitter<string> = new EventEmitter();

  constructor() { }

  ngOnInit(): void {
  }

  onRouteToDetail(id:string){
    this.routeToCourseDetail.emit(id);
  }

  calulateDaysLeft(){
    const createdAt = this.course.createdAt.toDate()
    const today:Date = new Date()
    const dateDiff = this.getDifferenceInDays(createdAt,today)
    if (this.course.length - dateDiff > 0){
      return this.course.length - dateDiff
    }
    return 0
  }
  getDifferenceInDays(date1:Date, date2:Date) {
    const Difference_In_Time = date2.getTime() - date1.getTime(); 
    const Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24); 
    return Math.ceil(Difference_In_Days)
  }
}
